import { jsx as f } from "react/jsx-runtime";
import l from "react";
import { TEXT_OPACITY_MAP as p } from "../Text/Text.js";
import { ui as o } from "../ui.js";
import { clsx as _ } from "../../utils/clsx.js";
import '../../assets/Icon.css';const d = "_root_sqbzn_1", u = {
  root: d
}, h = l.forwardRef(function(t, r) {
  const {
    color: c = "inherit",
    size: s = "normal",
    opacity: n = "100",
    className: i,
    children: e
  } = t, m = _(u.root, i), a = {
    color: o.color(c),
    fontSize: o.fontSize(s),
    opacity: p[n]
  };
  return /* @__PURE__ */ f("div", { ref: r, style: a, className: m, children: e });
});
export {
  h as Icon
};
